import '@theme/global';


const avensaiVideoGalleryOrders = new WeakMap();
const avensaiVideoGalleryUpdates = new WeakMap();

function avensaiMoveMedia(container, ordered) {
  let reference = container.firstElementChild;
  for (const item of ordered) {
    if (item === reference) {
      reference = reference.nextElementSibling;
    } else if (typeof container.moveBefore === 'function') {
      container.moveBefore(item, reference);
    } else {
      container.insertBefore(item, reference);
    }
  }
}

function avensaiOrderVideoGallery(gallery, variant, jumpMedia) {
  const slider = gallery.querySelector('.hdt-product-media__main hdt-slider');
  const container = slider?.querySelector('.hdt-slider__container');
  if (!container || !gallery.querySelector('.hdt-product__media--video-frame')) return;
  const items = Array.from(container.children).filter(item => item.hasAttribute('data-media-id'));
  const visibleImages = items.filter(item => !item.hidden && item.dataset.mediaType === 'image');
  const requestedId = String(variant.mdid || variant.featured_media?.id || '');
  const mainImage = visibleImages.find(item => item.dataset.mediaId === requestedId) || visibleImages[0];
  if (!mainImage) return;
  let originalOrder = avensaiVideoGalleryOrders.get(gallery);
  if (!originalOrder) {
    originalOrder = new Map();
    avensaiVideoGalleryOrders.set(gallery, originalOrder);
  }
  items.forEach(item => {
    if (!originalOrder.has(item.dataset.mediaId)) originalOrder.set(item.dataset.mediaId, originalOrder.size);
  });
  const stableItems = items.slice().sort((a, b) => originalOrder.get(a.dataset.mediaId) - originalOrder.get(b.dataset.mediaId));
  const videos = stableItems.filter(item => item.dataset.mediaType === 'video' || item.dataset.mediaType === 'external_video');
  if (!videos.length) return;
  const imageFrame = mainImage.querySelector?.('.hdt-product__media');
  if (imageFrame) {
    videos.forEach(item => {
      const videoFrame = item.querySelector('.hdt-product__media--video-frame');
      if (!videoFrame) return;
      ['--aspect-ratioapt', '--mw-media'].forEach(property => {
        const value = imageFrame.style.getPropertyValue(property);
        if (value) videoFrame.style.setProperty(property, value);
      });
    });
  }
  const ordered = [mainImage, ...videos, ...stableItems.filter(item => item !== mainImage && !videos.includes(item))];
  const previousSlide = items.find(item => item.classList.contains('is-selected') && !item.hidden);
  const target = jumpMedia === false && previousSlide ? previousSlide : mainImage;
  if (target.dataset.mediaType === 'image') {
    gallery.querySelectorAll('hdt-video-player[playing]').forEach(player => player.pause?.());
  }
  avensaiMoveMedia(container, ordered);
  const thumb = gallery.querySelector('hdt-slider-thumb');
  const thumbContainer = thumb?.querySelector('.hdt-slider__container');
  if (thumbContainer) {
    const thumbs = Array.from(thumbContainer.children);
    const byId = new Map(thumbs.map(item => [item.dataset.mediaId, item]));
    const orderedThumbs = ordered.map(item => byId.get(item.dataset.mediaId)).filter(Boolean);
    avensaiMoveMedia(thumbContainer, orderedThumbs);
  }
  const visibleIndex = ordered.filter(item => !item.hidden).indexOf(target);
  slider.reInit({ startIndex: Math.max(0, visibleIndex) });
  thumb?.reInit({ startIndex: Math.max(0, visibleIndex) });
  if (slider.isActive) slider.goToTarget(target, true);
}

document.addEventListener('variant:change', event => {
  const form = event.target;
  const variant = event.detail?.variant;
  if (!(form instanceof HTMLFormElement) || !variant) return;
  document.querySelectorAll('hdt-product-media[form]').forEach(gallery => {
    if (gallery.getAttribute('form') !== form.getAttribute('id')) return;
    const update = (avensaiVideoGalleryUpdates.get(gallery) || 0) + 1;
    avensaiVideoGalleryUpdates.set(gallery, update);
    queueMicrotask(() => {
      if (!gallery.isConnected || avensaiVideoGalleryUpdates.get(gallery) !== update) return;
      const selectedId = form.elements.namedItem('id')?.value;
      if (selectedId && String(selectedId) !== String(variant.id)) return;
      avensaiOrderVideoGallery(gallery, variant, event.detail.jumpMedia);
    });
  });
}, true);


  if (!customElements.get('avensai-size-guide')) {
    customElements.define('avensai-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.setUnit(this.dataset.unit === 'inch' ? 'inch' : 'cm', false);
        this.overflowObserver?.disconnect();
        cancelAnimationFrame(this.overflowFrame);
        const signal = this.abortController.signal;
        this.overflowFrame = requestAnimationFrame(() => {
          if (signal.aborted || !this.isConnected) return;
          this.overflowObserver = new ResizeObserver(() => this.updateOverflow());
          this.querySelectorAll('.av-size-guide__table-wrap, table').forEach(node => this.overflowObserver.observe(node));
          this.updateOverflow();
        });
        this.closest('details')?.addEventListener('toggle', () => this.updateOverflow(), {signal});
        document.addEventListener('click', event => {
          const link = event.target.closest('[data-size-guide-link]');
          if (!link || link.hash !== '#' + this.id || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.revealFromLink(link, this.abortController.signal);
        }, {signal: this.abortController.signal});
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-unit-button]');
          if (button && this.contains(button)) this.setUnit(button.dataset.unitButton, true);
        }, {signal: this.abortController.signal});
      }
      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.overflowFrame);
        this.overflowObserver?.disconnect();
      }
      updateOverflow() {
        if (!this.isConnected) return;
        const wrap = this.querySelector('.av-size-guide__table-wrap');
        const hint = this.querySelector('.av-size-guide__scroll-hint');
        if (hint) hint.toggleAttribute('data-overflow', Boolean(wrap && wrap.clientWidth > 0 && wrap.scrollWidth > wrap.clientWidth + 1));
      }
      async revealFromLink(link, signal) {
        const panel = this.closest('details');
        const summary = panel?.querySelector(':scope > summary');
        const group = panel?.closest('hdt-accordion-group');
        if (panel && !panel.open) summary?.click();
        const animations = (group || panel || this).getAnimations({subtree: true});
        await Promise.allSettled(animations.map(animation => animation.finished));
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (signal.aborted || !this.isConnected || (panel && !panel.open)) return;
        if (location.hash !== link.hash) history.pushState(null, '', link.hash);
        this.focus({preventScroll: true});
        (summary || this).scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
      formatMeasurement(raw, unit) {
        const value = raw.trim().replace(/,/g, '.');
        if (!/^\d+(?:\.\d+)?(?:\s*[-–—]\s*\d+(?:\.\d+)?)?$/.test(value)) return this.dataset.empty || '—';
        const parts = value.split(/\s*[-–—]\s*/).map(Number);
        if (parts.some(number => !Number.isFinite(number) || number <= 0)) return this.dataset.empty || '—';
        return parts.map(number => unit === 'inch' ? (number / 2.54).toFixed(1) : String(number)).join('–');
      }
      setUnit(unit, announce) {
        if (unit !== 'cm' && unit !== 'inch') return;
        this.dataset.unit = unit;
        this.querySelectorAll('[data-unit-button]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.unitButton === unit));
        });
        this.querySelectorAll('[data-unit-label]').forEach(label => { label.textContent = unit; });
        this.querySelectorAll('[data-measurement-cm]').forEach(cell => {
          cell.textContent = this.formatMeasurement(cell.dataset.measurementCm, unit);
        });
        const status = this.querySelector('[data-unit-status]');
        if (status && announce) status.textContent = this.dataset.announcement.replace('[unit]', unit);
        this.updateOverflow();
      }
    });
  }


const avensaiDirectCheckoutRequests = new WeakMap();
let avensaiDirectCheckoutOwner = null;

class AvensaiDirectCheckout extends HTMLElement {
  connectedCallback() {
    this.lifecycle?.abort();
    clearTimeout(this.stateSyncTimer);
    this.lifecycle = new AbortController();
    const signal = this.lifecycle.signal;
    queueMicrotask(() => {
      if (signal.aborted || !this.isConnected) return;
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-direct-checkout-label]');
      this.form = document.getElementById(this.getAttribute('form'));
      if (!this.button || !(this.form instanceof HTMLFormElement)) return;
      try { this.initialVariant = JSON.parse(this.dataset.variant || 'null'); } catch { this.initialVariant = null; }
      if (this.initialVariant) {
        Object.assign(this.initialVariant, {
          inventory_management: this.dataset.inventoryManagement || null,
          inventory_policy: this.dataset.inventoryPolicy,
          inventory_quantity: Number(this.dataset.inventoryQuantity),
          quantity_rule: {min: Number(this.dataset.min || 1), max: this.dataset.max ? Number(this.dataset.max) : null, increment: Number(this.dataset.step || 1)}
        });
      }
      this.button.addEventListener('click', event => this.checkout(event), {signal});
      const update = event => {
        const picker = this.variantPicker;
        if (event.target !== this.form && event.target.form !== this.form && !picker?.contains(event.target)) return;
        if (event.type === 'variant:change') this.changedVariant = event.detail?.variant || null;
        this.cancelRequest();
        queueMicrotask(() => { if (!signal.aborted) this.syncButton(); });
      };
      ['input', 'change', 'variant:change'].forEach(type => document.addEventListener(type, update, {capture: true, signal}));
      document.addEventListener('submit', event => {
        if (!this.request) return;
        const target = event.target;
        if (target === this.form || target.closest?.('hdt-sticky-btn-atc')?.getAttribute('form') === this.form.getAttribute('id')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {capture: true, signal});
      ['pageshow', 'pagehide'].forEach(type => window.addEventListener(type, () => {
        this.cancelRequest();
        this.syncButton();
        clearTimeout(this.stateSyncTimer);
        if (type === 'pageshow') this.stateSyncTimer = setTimeout(() => {
          if (!signal.aborted && this.isConnected) this.syncButton();
        }, 0);
      }, {signal}));
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => {
        if (this.request) {
          const state = this.snapshot(true);
          if (!state || state.key !== this.request.state.key) this.cancelRequest();
        }
        this.syncButton();
      });
      this.observer.observe(this.form, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'min', 'max', 'step', 'value', 'data-avensai-checkout-pending']});
      if (this.variantPicker) this.observer.observe(this.variantPicker, {attributes: true, attributeFilter: ['class', 'no-pick', 'data-option-update-pending', 'data-option-update-error', 'selected-variant']});
      this.syncButton();
    });
  }

  disconnectedCallback() {
    this.lifecycle?.abort();
    clearTimeout(this.stateSyncTimer);
    this.observer?.disconnect();
    this.cancelRequest();
  }

  get variantPicker() {
    const id = this.form?.getAttribute('id');
    return id ? Array.from(document.querySelectorAll('hdt-variant-picker[form]')).find(picker => picker.getAttribute('form') === id) : null;
  }

  snapshot(allowOwnRequest = false) {
    if (!this.isConnected || !this.form?.isConnected || this.form.checkBreak || this.form.closest('wrapp-hdt-pr-frm')?._avensaiSubmitting) return null;
    const active = avensaiDirectCheckoutRequests.get(this.form);
    if (active && (!allowOwnRequest || active !== this.request)) return null;
    const picker = this.variantPicker;
    if (picker && (picker.hasAttribute('no-pick') || picker.hasAttribute('data-option-update-pending') || picker.hasAttribute('data-option-update-error') || picker.classList.contains('loading'))) return null;
    const data = new FormData(this.form);
    const ids = [...new Set(data.getAll('id'))];
    if (ids.length !== 1 || typeof ids[0] !== 'string' || !/^\d+$/.test(ids[0]) || !Number(ids[0])) return null;
    const id = ids[0];
    let variant = picker ? picker.currentVariant : this.changedVariant === undefined ? this.initialVariant : this.changedVariant;
    if (picker && variant === undefined && String(this.initialVariant?.id) === id && picker.getAttribute('selected-variant') === id) {
      const selection = picker.getOptionSelection?.();
      const options = this.initialVariant.options;
      if (Array.isArray(selection) && Array.isArray(options) && selection.length === options.length && selection.every((option, index) => option[2] === options[index])) variant = this.initialVariant;
    }
    if (!variant?.available || String(variant.id) !== id) return null;
    const quantities = [...new Set(data.getAll('quantity'))];
    if (quantities.length > 1) return null;
    const quantity = quantities.length ? Number(quantities[0]) : 1;
    const rules = variant.quantity_rule || {};
    const min = Math.max(1, Number(rules.min) || 1);
    const increment = Math.max(1, Number(rules.increment) || 1);
    let max = rules.max == null ? Infinity : Number(rules.max);
    if (variant.inventory_management && variant.inventory_policy !== 'continue' && Number.isFinite(Number(variant.inventory_quantity))) max = Math.min(max, Math.max(0, Number(variant.inventory_quantity)));
    if (!Number.isSafeInteger(quantity) || quantity < min || quantity > max || (quantity - min) % increment !== 0) return null;
    const quantityInput = this.form.elements.namedItem('quantity');
    if (quantityInput?.validity && !quantityInput.validity.valid) return null;
    const plans = [...new Set(data.getAll('selling_plan').filter(Boolean))];
    if (plans.length > 1 || (plans.length && !/^\d+$/.test(plans[0]))) return null;
    const line = {merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity};
    if (plans.length) line.sellingPlanId = `gid://shopify/SellingPlan/${plans[0]}`;
    const attributes = new Map();
    for (const [name, value] of data.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (!match) continue;
      if (typeof value !== 'string') {
        if (value.size === 0) continue;
        return null;
      }
      attributes.set(match[1], value);
    }
    if (attributes.size) line.attributes = [...attributes].sort(([a], [b]) => a.localeCompare(b)).map(([key, value]) => ({key, value}));
    const input = {lines: [line]};
    if (/^[A-Z]{2}$/.test(this.dataset.country || '')) input.buyerIdentity = {countryCode: this.dataset.country};
    return {input, line, key: JSON.stringify(input)};
  }

  syncButton() {
    if (!this.button) return;
    const busy = Boolean(this.request);
    const disabled = busy || !this.snapshot();
    if (this.button.disabled !== disabled) this.button.disabled = disabled;
    if (busy) this.button.setAttribute('aria-busy', 'true');
    else this.button.removeAttribute('aria-busy');
    const text = busy ? this.dataset.loading : this.dataset.label;
    if (this.label && this.label.textContent !== text) this.label.textContent = text;
  }

  showError(visible) {
    const area = this.form?.querySelector('[ref="addToCartTextError"]');
    const text = area?.querySelector('.hdt-error-message');
    if (!area || !text) return;
    area.hidden = !visible;
    if (visible) text.textContent = this.dataset.error;
  }

  cancelRequest() {
    const request = this.request;
    if (!request) return;
    this.request = null;
    if (avensaiDirectCheckoutOwner === this) avensaiDirectCheckoutOwner = null;
    request.controller.abort();
    clearTimeout(request.timeout);
    if (avensaiDirectCheckoutRequests.get(request.form) === request) {
      avensaiDirectCheckoutRequests.delete(request.form);
      request.form.removeAttribute('data-avensai-checkout-pending');
    }
    this.syncButton();
  }

  validCheckoutUrl(value) {
    const url = new URL(value);
    const hosts = [window.location.hostname, this.dataset.checkoutDomain, this.dataset.shopDomain].filter(Boolean).map(host => host.toLowerCase());
    if (url.protocol !== 'https:' || url.username || url.password || url.port || !hosts.includes(url.hostname.toLowerCase()) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart\/c\/|checkouts\/)/i.test(url.pathname)) throw new Error('Invalid checkout destination');
    return url;
  }

  async checkout(event) {
    event.preventDefault();
    if (this.request || !this.form) return;
    if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
    const state = this.snapshot();
    if (!state) { this.showError(true); this.syncButton(); return; }
    avensaiDirectCheckoutOwner?.cancelRequest();
    avensaiDirectCheckoutOwner = this;
    const request = {state, form: this.form, controller: new AbortController(), navigating: false};
    this.request = request;
    avensaiDirectCheckoutRequests.set(this.form, request);
    this.form.setAttribute('data-avensai-checkout-pending', '');
    this.showError(false);
    this.syncButton();
    request.timeout = setTimeout(() => { request.timedOut = true; request.controller.abort(); }, 20000);
    try {
      const response = await fetch('/api/2026-10/graphql.json', {
        method: 'POST', credentials: 'omit', signal: request.controller.signal,
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({query: 'mutation AvensaiDirectCheckout($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } sellingPlanAllocation { sellingPlan { id } } attributes { key value } } } } userErrors { message } warnings { code } } }', variables: {input: state.input}})
      });
      if (!response.ok) throw new Error('Checkout request failed');
      const result = await response.json();
      if (this.request !== request || request.controller.signal.aborted || !this.isConnected) return;
      const payload = result.data?.cartCreate;
      const cart = payload?.cart;
      const lines = cart?.lines?.nodes;
      if (result.errors?.length || !payload || !Array.isArray(payload.userErrors) || payload.userErrors.length || !Array.isArray(payload.warnings) || payload.warnings.length || !Array.isArray(lines) || lines.length !== 1 || cart.totalQuantity !== state.line.quantity) throw new Error('Checkout did not contain the requested selection');
      const line = lines[0];
      const attributes = (line.attributes || []).slice().sort((a, b) => a.key.localeCompare(b.key));
      if (line.merchandise?.id !== state.line.merchandiseId || line.quantity !== state.line.quantity || (line.sellingPlanAllocation?.sellingPlan?.id || '') !== (state.line.sellingPlanId || '') || JSON.stringify(attributes) !== JSON.stringify(state.line.attributes || [])) throw new Error('Checkout selection changed');
      const current = this.snapshot(true);
      if (!current || current.key !== state.key || !this.form.checkValidity()) return;
      const destination = this.validCheckoutUrl(cart.checkoutUrl);
      clearTimeout(request.timeout);
      request.navigating = true;
      window.location.assign(destination.href);
    } catch (error) {
      request.navigating = false;
      if (this.request === request && this.isConnected && (error.name !== 'AbortError' || request.timedOut)) this.showError(true);
    } finally {
      if (this.request === request && !request.navigating) this.cancelRequest();
    }
  }
}

if (!customElements.get('avensai-direct-checkout')) customElements.define('avensai-direct-checkout', AvensaiDirectCheckout);
